import { EnumDto } from "../dto/enum.dto";
import { ILabeledEntity } from "../interfaces/labeled-entity.interface";

/** The `shared.enums.*` groups of the root translation files, one per API enum list. */
export type EnumTranslationGroup =
  | 'buildingBlockPurposes'
  | 'buildingBlockMainTypes'
  | 'buildingBlockSubTypes'
  | 'binauralFrequencyVariations'
  | 'binauralSoundTypes'
  | 'programIntensityLevels'
  | 'programSessionFrequencies';

/** Translation key of an enum code's label, e.g. `shared.enums.buildingBlockPurposes.relaxation`. */
export function enumLabelKey(group: EnumTranslationGroup, code: string): string {
  return `shared.enums.${group}.${code}`;
}

export class EnumMapper {
  /**
   * `title` is the translation key of the code's label (see `enumLabelKey`); render it with the
   * transloco pipe or `TranslocoService.translate`.
   */
  public static toModel<T>(dto: EnumDto, group: EnumTranslationGroup): T {
    const e: ILabeledEntity = {
      id: dto.id,
      title: enumLabelKey(group, dto.description),
      code: dto.description
    }
    return e as T;
  }
}
